import React from "react";
import { useWizard } from "../../lib/wizardStore";
import { Sparkles } from "lucide-react";

export default function ServicesStep() {
  const { state, setServices } = useWizard();

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          What do customers hire you to do?
        </h2>
        <p className="text-slate-500 mt-2">
          Write it your way — we’ll keep your exact words. Use commas, line breaks, or whatever feels natural.
        </p>
      </div>

      <textarea
        data-testid="services-textarea"
        value={state.services}
        onChange={(e) => setServices(e.target.value)}
        rows={8}
        placeholder={"e.g.\n— Men's haircuts\n— Hot towel shaves\n— Beard trims\n— Kids cuts (under 12)"}
        className="w-full rounded-2xl bg-slate-50 border border-transparent py-4 px-5 text-slate-900 placeholder:text-slate-400 focus:bg-white focus:border-emerald-500 focus-ring transition-all outline-none resize-none leading-relaxed"
      />

      <div className="flex items-start gap-2.5 bg-emerald-50/60 border border-emerald-100 rounded-xl p-3.5">
        <Sparkles className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" />
        <p className="text-xs text-emerald-900/80 leading-relaxed">
          We never rewrite your services. Your exact text appears on your Google profile — and in the live preview to the right.
        </p>
      </div>
    </div>
  );
}
